export const CalculatorTranslations = {
  submitLabel: 'Tarife anzeigen',
  heatSubmitLabel: 'Tarife berechnen',
  invalid: 'Hier stimmt was nicht.',
  missing: 'Hier fehlt noch eine Angabe.',
} as const;
